export default "__VITE_ASSET__1d5a0fe0__"